/* eslint-disable react/no-array-index-key */
import React from 'react';
import styled from 'styled-components';
import { THit } from '@com/core/common/types/catalog';
import ProductBoxMobile from './ProductBoxMobile';

type TProps = {
    products: THit[];
};

const VerticalProductBoxes = ({ products }: TProps): JSX.Element => {
    const getProductBoxRows = () => {
        const rows = [];
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < products.length; i++) {
            if (i % 2 !== 0) {
                rows[rows.length - 1].push(products[i]);
            } else {
                rows.push([products[i]]);
            }
        }
        return rows;
    };

    const groupedProducts = getProductBoxRows();

    return (
        <ProductBoxGrid>
            {groupedProducts.map((group, groupIndex) => (
                <ProductBoxRow key={groupIndex}>
                    {group.map(product => (
                        <ProductBoxWrapper key={product.offer_code}>
                            <ProductBoxMobile vertical product={product} />
                        </ProductBoxWrapper>
                    ))}
                </ProductBoxRow>
            ))}
        </ProductBoxGrid>
    );
};

const STAGGER_OFFSET = 32;
const GRID_SPACING = 3;

const ProductBoxGrid = styled.div`
    padding-top: ${STAGGER_OFFSET}px;
    ${({ theme: { right } }): string => `padding-${right}: ${GRID_SPACING}px`};
`;

const ProductBoxRow = styled.div`
    display: flex;
    margin-top: -${STAGGER_OFFSET - GRID_SPACING}px;
`;

const ProductBoxWrapper = styled.div`
    flex: 0 0 50%;
    ${({ theme: { left } }): string => `padding-${left}: ${GRID_SPACING}px`};

    &:nth-child(odd) {
        margin-top: ${STAGGER_OFFSET}px;
    }
`;

export default VerticalProductBoxes;
